export default __webpack_public_path__ + "static/media/greenswappLogo.df7bbbfe.png";